import { Phone, ArrowRight } from 'lucide-react';
import Button from '../ui/Button';
import { useLanguage } from '../../context/LanguageContext';

export default function ReservationCTA() {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-24 bg-primary-800 dark:bg-primary-900 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          {t('reservationCta.title')}
        </h2>
        <p className="text-xl text-primary-200 mb-8 max-w-2xl mx-auto">
          {t('reservationCta.description')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button to="/reservation" variant="white" size="lg">
            {t('reservationCta.cta')}
            <ArrowRight className="w-5 h-5" />
          </Button>

          <span className="text-primary-300">
            {t('reservationCta.or')}
          </span>

          <a
            href="tel:+4989987654"
            className="inline-flex items-center gap-2 text-white hover:text-accent-400 transition-colors text-lg font-medium"
          >
            <Phone className="w-5 h-5" />
            089 - 987 654 32
          </a>
        </div>
      </div>
    </section>
  );
}
